import React from "react";

import { exportP2POutLegConfig } from "constants/p2pLeg/containerConfig";

import { NLISP2PLegFileTab } from "./NLISP2PLegFileTab";

export const NLISExportP2POutFileInfo = () => (
  <NLISP2PLegFileTab config={exportP2POutLegConfig} />
);
